



































































import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter, State } from 'vuex-class'

import {
  CreateItemGroupModal,
  InfiniteScroll,
  ItemGroupTile,
  NetworkErrorEmptyState,
  UpdateBrandModal,
  VsLoading
} from '@/components'

import { EmptyState, MobileLayout } from '@/layouts/components'

import {
  AsyncState,
  DropDownButton,
  ItemGroup,
  ItemGroupResourcePayload,
  ModalState
} from '@/models'

import { RootState } from '@/store/state'

import { isFood } from '@/utils'

@Component({
  components: {
    CreateItemGroupModal,
    EmptyState,
    InfiniteScroll,
    ItemGroupTile,
    MobileLayout,
    NetworkErrorEmptyState,
    UpdateBrandModal,
    VsLoading
  }
})
export default class ItemGroups extends Vue {
  loadState = new AsyncState()
  createState = new ModalState()
  updateBrandState = new ModalState()

  get buttons (): DropDownButton[] {
    return [
      {
        icon: 'more_vert',
        color: 'dark',
        items: [
          {
            text: 'Alterar capa',
            handler: () => { this.updateBrandState.isActive = true }
          }
        ]
      }
    ]
  }

  get isWaiting () {
    return (
      this.createState.isPending ||
      this.updateBrandState.isPending
    )
  }

  get showFab () {
    return this.total > 0 || this.loadState.isResolved
  }

  get itemGroupTitle () {
    return isFood() ? 'Cardápio' : 'Catálogo'
  }

  get emptyStateIcon () {
    return isFood() ? 'restaurant_menu' : 'list_alt'
  }

  @State((state: RootState) => state.menu.itemGroups.total)
  readonly total!: number

  @State((state: RootState) => state.menu.itemGroups.didLoadAll)
  readonly didLoadAll!: boolean

  @Getter('menu/orderedItemGroups')
  readonly itemGroups!: ItemGroup[]

  @Action('menu/loadItemGroupPage')
  loadItemGroupPage!: () => Promise<void>

  @Action('menu/createItemGroup')
  createItemGroup!: (payload: ItemGroupResourcePayload) => Promise<ItemGroup>

  @Action('menu/updateBrand')
  updateBrand!: (imageFile: File) => Promise<void>

  created () {
    if (this.total === 0) {
      this.reload()
    } else {
      this.loadState.touch()
    }
  }

  async reload () {
    try {
      await this.loadMore()
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async loadMore () {
    await this.loadState.handle(
      this.loadItemGroupPage()
    )

    return this.itemGroups.length > 0
  }

  async handleCreateItemGroup (payload: ItemGroupResourcePayload) {
    try {
      const itemGroup = await this.createState.handle(
        this.createItemGroup(payload)
      )

      this.$router.push({
        name: 'ItemGroupDetails',
        params: {
          itemGroupId: itemGroup.id.toString()
        }
      })
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível criar nova categoria.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async handleUpdateBrand ({ file, callback }: { file: File; callback: () => void }) {
    try {
      await this.updateBrandState.handle(
        this.updateBrand(file)
      )

      callback()

      this.$vs.notify({
        title: 'Capa alterada.',
        color: 'success',
        fullWidth: true
      })
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível alterar a capa.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }
}
